import { FilterSetType } from '@statsbomb/parachute-types';
import dayjs from 'dayjs';
import { atom } from 'jotai';
import { userDetailsAtom } from '@/atoms/queries/user';
import { filterSetsAtom } from '@/atoms/queries/userConfigs';

// Filter sets have no "last used" time, so the most recently saved one stands in for the search to resume.
// Only the user's own, named Player Scout searches count: shared and system sets aren't "your saved search".
export const homeLatestPlayerSearchAtom = atom(async get => {
  const [filterSets, userDetails] = await Promise.all([get(filterSetsAtom), get(userDetailsAtom)]);

  return filterSets
    .filter(
      ({ type, hudlUserId, definition }) =>
        type === FilterSetType.PLAYER_DATA_LOCKER &&
        hudlUserId === userDetails.user.hudlUserId &&
        !!definition.titleSettings.title,
    )
    .reduce<(typeof filterSets)[number] | undefined>(
      (latest, filterSet) => (!latest || dayjs(filterSet.updatedAt).isAfter(latest.updatedAt) ? filterSet : latest),
      undefined,
    );
});
